import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
export function UserMessage({
  children
}) {
  return /*#__PURE__*/_jsx(Flex, {
    "data-test-id": "user-message-bubble",
    flexDirection: "column",
    alignItems: "end",
    inlineSize: "100%",
    children: /*#__PURE__*/_jsx(Flex, {
      backgroundColor: "fill-surface-recessed",
      borderWidth: "100",
      borderStyle: "solid",
      borderColor: "border-core-subtle",
      borderRadius: "400",
      borderEndEndRadius: "0",
      inlineSize: "fit-content",
      maxInlineSize: "min(700px, 100%)",
      paddingBlock: "200",
      paddingInline: "300",
      children: /*#__PURE__*/_jsx(Text, {
        as: "div",
        wordBreak: "break-word",
        textAlign: "left",
        whiteSpace: "pre-wrap",
        children: children
      })
    })
  });
}